const privacyPolicy = {
    title: "Privacy Policy",
    slug: "privacy-policy",
    lastUpdated: "27 July 2026",

    heroTitle: "Privacy Policy",

    heroDescription:
        "Your privacy is important to us. This Privacy Policy explains how Horyzen Technologies collects, uses, stores, and protects your personal information when you use our website or interact with our services.",

    sections: [
        {
            id: "introduction",
            title: "Introduction",
            paragraphs: [
                'Welcome to Horyzen Technologies ("Company", "we", "our", or "us"). This Privacy Policy describes how we collect, use, disclose, and safeguard your information when you visit our website https://horyzen.in or use any of our services, including software development, IT consulting, internship programs, training, and technical support.',
                "By accessing our website or using our Services, you consent to the collection and use of your information as described in this Privacy Policy. If you do not agree with the terms outlined below, please discontinue the use of our website."
            ]
        },

        {
            id: "information-collected",
            title: "Information We Collect",
            paragraphs: [
                "We may collect personal and technical information that you voluntarily provide or that is automatically collected while using our website."
            ],

            list: [
                "Full name",
                "Email address",
                "Phone number",
                "Company or organization name",
                "Postal address (when applicable)",
                "Resume or CV submitted for internship or job applications",
                "Educational details",
                "Project inquiry information",
                "Communication preferences",
                "IP address",
                "Browser type and version",
                "Device information",
                "Operating system",
                "Website usage statistics",
                "Cookies and similar tracking technologies"
            ]
        },

        {
            id: "how-we-collect",
            title: "How We Collect Information",
            paragraphs: [
                "Information is collected directly from you as well as automatically through your interaction with our website."
            ],

            list: [
                "Contact forms",
                "Internship application forms",
                "Career application forms",
                "Business inquiry forms",
                "Newsletter subscriptions",
                "Emails sent to us",
                "Cookies",
                "Website analytics tools",
                "Server logs"
            ]
        },

        {
            id: "how-we-use",
            title: "How We Use Your Information",
            paragraphs: [
                "The information we collect helps us provide better services and improve your overall experience."
            ],

            list: [
                "Respond to business inquiries",
                "Process internship applications",
                "Evaluate job applications",
                "Provide requested IT services",
                "Communicate project updates",
                "Schedule meetings or consultations",
                "Improve website performance",
                "Maintain website security",
                "Prevent fraudulent activities",
                "Send service announcements",
                "Provide technical support",
                "Improve customer experience",
                "Comply with applicable legal obligations"
            ]
        },

        {
            id: "cookies",
            title: "Cookies and Tracking Technologies",
            paragraphs: [
                "Our website uses cookies and similar technologies to improve functionality, analyze website traffic, and enhance user experience.",
                "Cookies help us remember your preferences, understand visitor behavior, and improve our website over time.",
                "You may choose to disable cookies through your browser settings; however, certain features of the website may not function properly."
            ]
        },

        {
            id: "sharing-information",
            title: "Sharing of Information",
            paragraphs: [
                "Horyzen Technologies does not sell, rent, or trade your personal information to third parties.",
                "We may share information only when necessary for business operations or when legally required."
            ],

            list: [
                "Trusted service providers assisting in website operations",
                "Cloud hosting providers",
                "Email communication providers",
                "Government authorities when legally required",
                "Professional advisors including legal or financial consultants",
                "Business partners involved in delivering requested services"
            ]
        },

        {
            id: "data-security",
            title: "Data Security",
            paragraphs: [
                "We implement appropriate administrative, technical, and organizational security measures to protect your personal information against unauthorized access, disclosure, alteration, or destruction.",
                "Although we strive to use commercially acceptable methods to protect your information, no method of transmission over the Internet or electronic storage is completely secure."
            ]
        },

        {
            id: "data-retention",
            title: "Data Retention",
            paragraphs: [
                "We retain personal information only for as long as necessary to fulfill the purposes described in this Privacy Policy or as required by applicable law.",
                "Internship applications, project inquiries, and business communications may be retained for administrative, legal, and operational purposes."
            ]
        },

        {
            id: "user-rights",
            title: "Your Rights",
            paragraphs: [
                "Depending on applicable law, you may have certain rights regarding your personal information."
            ],

            list: [
                "Request access to your personal information",
                "Request correction of inaccurate information",
                "Request deletion of your personal data",
                "Withdraw previously provided consent",
                "Request restriction of data processing where applicable",
                "Raise concerns regarding the handling of your information"
            ]
        },

        {
            id: "third-party-services",
            title: "Third-Party Services",
            paragraphs: [
                "Our website may integrate third-party services to improve functionality and user experience.",
                "These services operate under their own privacy policies, and Horyzen Technologies is not responsible for their independent privacy practices."
            ],

            list: [
                "Google Analytics",
                "Google Maps",
                "Cloud hosting providers",
                "Email service providers",
                "Payment gateways (where applicable)",
                "Social media platforms"
            ]
        },

        {
            id: "childrens-privacy",
            title: "Children's Privacy",
            paragraphs: [
                "Our website and Services are not intended for children under the age of 18 without parental or guardian supervision.",
                "We do not knowingly collect personal information from children. If such information is identified, we will take reasonable steps to remove it."
            ]
        },

        {
            id: "policy-changes",
            title: "Changes to this Privacy Policy",
            paragraphs: [
                "Horyzen Technologies reserves the right to modify this Privacy Policy at any time.",
                "Any updates become effective immediately after publication on this website.",
                "We encourage users to review this Privacy Policy periodically to remain informed about how we protect personal information."
            ]
        },

        {
            id: "contact",
            title: "Contact Us",
            paragraphs: [
                "If you have any questions, requests, or concerns regarding this Privacy Policy or our privacy practices, please contact us."
            ],

            contact: {
                company: "Horyzen Technologies",
                email: "info@horyzen.in",
                website: "https://horyzen.in"
            }
        }
    ]
};

export default privacyPolicy;